import { render, staticRenderFns } from "./numerosBlackList.vue?vue&type=template&id=179360e9&scoped=true"
import script from "./numerosBlackList.vue?vue&type=script&lang=js"
export * from "./numerosBlackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179360e9",
  null
  
)

export default component.exports